/** Who is signed in on this tablet, shared by sign-in, the robot gateway and sync. */
export interface TabletSession {
  /** The tablet's own id for this sign-in; offline sessions are uploaded under it. */
  readonly id: string;
  readonly operatorId: number;
  readonly operatorName: string;
  /** A service account (the Evesix team). */
  readonly service: boolean;
  /** Signed in with no data, against the offline PIN check. */
  readonly offline: boolean;
  readonly startedAt: string;
}

export class SessionState {
  #current: TabletSession | null = null;

  get current(): TabletSession | null {
    return this.#current;
  }

  set(session: TabletSession): void {
    this.#current = session;
  }

  clear(): void {
    this.#current = null;
  }
}
